import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {MeterTreeName} from '../dashboard/dashboard.types';
import {loadMeterTreeNamePreference, saveMeterTreeNamePreference} from './intermediate-meter.utils';

@Injectable({providedIn: 'root'})
export class MeterTreeNamePreferenceService {
    private readonly selectedNameSubject = new BehaviorSubject<MeterTreeName>(MeterTreeName.Name);
    private loadedUserKey: string | null = null;

    get selectedName$(): Observable<MeterTreeName> {
        return this.selectedNameSubject.asObservable();
    }

    selectedName(userId?: string): MeterTreeName {
        this.loadForUser(userId);
        return this.selectedNameSubject.value;
    }

    selectName(selectedName: MeterTreeName, userId?: string): void {
        this.loadedUserKey = this.userKey(userId);
        this.storage(storage => saveMeterTreeNamePreference(storage, selectedName, userId));
        if (this.selectedNameSubject.value === selectedName) return;
        this.selectedNameSubject.next(selectedName);
    }

    private loadForUser(userId?: string): void {
        const userKey = this.userKey(userId);
        if (this.loadedUserKey === userKey) return;
        this.loadedUserKey = userKey;
        const selectedName = this.storage(storage =>
            loadMeterTreeNamePreference(storage, userId)
            || (userId ? loadMeterTreeNamePreference(storage) : null)
            || MeterTreeName.Name
        ) || MeterTreeName.Name;
        if (this.selectedNameSubject.value !== selectedName) {
            this.selectedNameSubject.next(selectedName);
        }
    }

    private userKey(userId?: string): string {
        return userId || 'anonymous';
    }

    private storage<T>(operation: (storage: Storage) => T): T | null {
        if (typeof localStorage === 'undefined') return null;
        try {
            return operation(localStorage);
        } catch {
            return null;
        }
    }
}
